var $ = require('jquery');
const { clarify } = require('@/domain/services/VueDataProvider');

module.exports = function () {
	// eslint-disable-next-line no-undef
	var currencySymbols = clarify(currencySymbolMap);
	var currencyField = $('#currency');

	var updateCurrencySymbol = function () {
		var code = currencyField.val();
		// eslint-disable-next-line no-prototype-builtins
		var symbol = currencySymbols.hasOwnProperty(code) ? currencySymbols[code] : code;
		$('#currency-symbol').text(symbol);
	};

	updateCurrencySymbol();
	$('#currency').on('change', updateCurrencySymbol);
};
